module.exports = "/static/media/user_icon.39e21191.png";